/*
 * Copyright (c) 2022, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
 * You may not alter or remove any copyright or other notice from copies of this content."
 */

import React, { Dispatch, SetStateAction, useContext } from 'react';

interface IEnterpriseSubscriptionContext {
  isEnterpriseUser: boolean;
  setIsEnterpriseUser: Dispatch<SetStateAction<boolean>>;
}

const EnterpriseSubscriptionContext = React.createContext({
  setIsEnterpriseUser: () => {},
  isEnterpriseUser: true,
} as IEnterpriseSubscriptionContext);
EnterpriseSubscriptionContext.displayName = 'EnterpriseSubscriptionProvider';
const { Provider: EnterpriseSubscriptionProvider } =
  EnterpriseSubscriptionContext;

const useEnterpriseSubscription = (): [
  boolean,
  Dispatch<SetStateAction<boolean>>
] => {
  const { isEnterpriseUser, setIsEnterpriseUser } = useContext(
    EnterpriseSubscriptionContext
  );
  return [isEnterpriseUser, setIsEnterpriseUser];
};

export { EnterpriseSubscriptionProvider, useEnterpriseSubscription };
